module.exports = __webpack_public_path__ + "static/body-language-thumbnail.cd1d7fd3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/body-language-thumbnail.jpg
// module id = 460
// module chunks = 59963396046441